import React from 'react';
import { paymentAndPayoutDetails } from 'Constants';
import {  DashboardSettingLayout } from 'Layouts';

import { DashboardLayoutWithDescription } from 'Pages/Dashboard/Components/LayoutWithDescription';
import { Content } from './Content';

export const PaymentAndPayout = () => {
	return (
		<DashboardSettingLayout>
			<DashboardLayoutWithDescription
				content={<Content/>}
				description={paymentAndPayoutDetails}/>
		</DashboardSettingLayout>
	);
};
